import update from "immutability-helper";
import { ProfileReduxActions } from "./Action";
import { KYBStatusCode } from "shared/helpers/Constants";

export interface ProfileState {
  firstName: string;
  lastName: string;
  phoneNumber: any;
  email: string;
  loadId: string;
  userId: string;
  isEmailVerified: boolean;
  isDocumentMappingCompleted: boolean;
  identityVerificationStatus: number;
  // LOAN
  loanAmount: number;
  loanTerm: number;
  loanStatus: number;
  expectedTime: string;
  expectedLoanDate: string;
  repaymentMethod: string;
  loanPurpose: string;
  loanPayBackOption: string;
  brokerCommissionRate: any;
  isReviewConfirmed: boolean;
  abn: any;
  isABNVerified: boolean;
  registeredEntityName: string;
  legalEntityType: string;
  entityAddress: string;
  averageMonthlyTurnOver: number;
  totalBusinessAssets: number;
  totalBusinessLiabilities: number;
  entityType: string;
  // SECURITY
  isPropertyOwned: boolean;
  noOfProperties: number;
  propertyType: string;
  propertyAddress: string;
  estimatedPropertyAmount: number;
  isAnyExistingLoan: boolean;
  existingLoanSettlementOption: string;
  existingLoanAmount: number;
  isAnyCaveats: boolean;
  properties: any[];
  //VERIFICATION
  // ---- DIRECTORS
  stakeholders: any[];
  // ---- PAYMENT
  paymentDetails: any;
  // ---- KYC
  kycDetails: any;
  kycId: string;
  // Finalise

  // Solicitor Details
  solicitorfirstName: string;
  solicitorLastName: string;
  solicitorBusinessName: string;
  solicitorWorkEmailAddress: string;

  // Bank Details
  BSB: number | string;
  accountName: string;
  accountNumber: number | string;
  // ADDITIONAL
  isPayment: boolean;
  documentStatus: string;
  signerStatus: string;
  signedDocumentUrl: string;
  signedDocumentName: string;
  isAllowedToEdit: any;
  showNonEditableMessage: any;

  // ------------ RND
  annualTurnover: number;
  hasATOClaims: boolean;
  hasTaxIncentive: boolean;
  taxYear: number;
  estimatedTaxFilingDate: string;
  estimatedExpenditureAmount: number;
  companyAddress: string;
  businnessOrCompanyAddress: string;
  auRegDate: any;

  // Accountant Details
  accountantFirstName: string;
  accountantLastName: string;
  accountantBusinessName: string;
  accountantWorkEmailAddress: string;
}

export interface CombinedProfileState {
  currentLoanType: "sbl" | "rnd";
  sblProfile: ProfileState;
  rndProfile: ProfileState;
  brokerAppDialog: any;
}

export const profileState: ProfileState = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  loadId: "",
  userId: "",
  isEmailVerified: false,
  isDocumentMappingCompleted: false,
  identityVerificationStatus: KYBStatusCode.PENDING,
  // LOAN
  loanAmount: null,
  loanTerm: null,
  loanStatus: 0,
  expectedTime: "",
  expectedLoanDate: null,
  repaymentMethod: "",
  loanPurpose: "",
  loanPayBackOption: "",
  brokerCommissionRate: null,
  isReviewConfirmed: false,
  abn: "",
  isABNVerified: false,
  registeredEntityName: "",
  legalEntityType: "",
  entityAddress: "",
  averageMonthlyTurnOver: null,
  totalBusinessAssets: null,
  totalBusinessLiabilities: null,
  entityType: "",
  // SECURITY
  isPropertyOwned: null,
  noOfProperties: null,
  propertyType: "",
  propertyAddress: "",
  estimatedPropertyAmount: null,
  isAnyExistingLoan: null,
  existingLoanSettlementOption: "",
  existingLoanAmount: null,
  isAnyCaveats: null,
  properties: [],
  // DIRECTORS
  stakeholders: [],
  // ---- PAYMENT
  paymentDetails: null,
  // ---- KYC
  kycDetails: null,
  kycId: "",
  // Solicitor Details
  solicitorfirstName: null,
  solicitorLastName: null,
  solicitorBusinessName: null,
  solicitorWorkEmailAddress: null,
  // Bank Details
  BSB: null,
  accountName: null,
  accountNumber: null,
  // ADDITIONAL
  isPayment: false,
  // Documents
  documentStatus: "",
  signerStatus: "",
  signedDocumentUrl: null,
  signedDocumentName: "",
  isAllowedToEdit: null,
  showNonEditableMessage: null,

  // ------------ RND
  annualTurnover: null,
  hasATOClaims: null,
  hasTaxIncentive: null,
  taxYear: null,
  estimatedTaxFilingDate: null,
  estimatedExpenditureAmount: null,
  companyAddress: null,
  businnessOrCompanyAddress: null,
  auRegDate: null,

  // Accountant Details
  accountantFirstName: null,
  accountantLastName: null,
  accountantBusinessName: null,
  accountantWorkEmailAddress: null,
};

const combinedProfileState: CombinedProfileState = {
  currentLoanType: null,
  sblProfile: { ...profileState },
  rndProfile: { ...profileState },
  brokerAppDialog: null,
};

const ProfileStateReducer = (
  state: CombinedProfileState = combinedProfileState,
  action: any = { type: "", payload: {} },
): CombinedProfileState => {
  switch (action.type) {
    case ProfileReduxActions.SET_SBL_PROFILE:
      return update(state, {
        sblProfile: {
          $merge: {
            ...action.payload,
          },
        },
      });

    case ProfileReduxActions.SET_RND_PROFILE:
      return update(state, {
        rndProfile: {
          $merge: {
            ...action.payload,
          },
        },
      });

    case ProfileReduxActions.SWITCH_PROFILE_LOAN_TYPE:
      return update(state, {
        currentLoanType: { $set: action.payload },
      });

    case ProfileReduxActions.BROKER_APP_DIALOG:
      return update(state, {
        brokerAppDialog: { $set: action.payload },
      });

    default:
      return state;
  }
};

export default ProfileStateReducer;
